// material ui
import { MenuItem, Select } from '@mui/material';

// feature-hooks
import { useAggregationParam } from '@/features/energyxplorer/hooks/useAggregationParam';

// components
import { inputSurfaceStyles } from '@/theme/Inputs/textFieldCustomization';

// TODO: i18n for option labels
const DEFAULT_OPTIONS = [
  { value: 'sum', label: 'Sum' },
  { value: 'mean', label: 'Gennemsnit' },
  { value: 'min', label: 'Min' },
  { value: 'max', label: 'Max' },
];

export default function AnalysisAggregateMenu({
  t,
  options = DEFAULT_OPTIONS,
  paramKey = 'aggregation',
}) {
  // * aggregation in URL, sum, mean, min, max
  const { aggregation, setAggregation } = useAggregationParam(paramKey);

  return (
    <Select
      value={aggregation}
      onChange={(event) => setAggregation(event.target.value)}
      size="small"
      variant="outlined"
      sx={inputSurfaceStyles}
      aria-label={
        t ? t('child_analysis.select_aggregation') : 'Vælg aggregation'
      }
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}
